import React from 'react';
import Hero       from '../components/Hero';
import Services   from '../components/Services';
import Calculator from '../components/Calculator';
import HowWeWork  from '../components/HowWeWork';
import FAQ        from '../components/FAQ';
import Contact    from '../components/Contact';
import useDocumentTitle from '../hooks/useDocumentTitle';

/* El blog no se enlaza desde la home hasta que sus artículos se reescriban:
   ver design/06-pendiente.md */
export default function HomePage() {
  useDocumentTitle('Qyntix · Estudio de software e IA');

  return (
    <main id="main">
      <Hero />
      <Services />
      <Calculator />
      <HowWeWork />
      <FAQ />
      <Contact />
    </main>
  );
}
